import React, {Component} from "react";

class NotFound extends Component{
    render() {
        return (
            <div>
                <h4 className="text-center">Not Found</h4>
            </div>
        );
    }
}

export default NotFound;